function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 14C30 14.66 29.46 15.2 28.8 15.2H25.2V18.8C25.2 19.46 24.66 20 24 20C23.34 20 22.8 19.46 22.8 18.8V15.2H19.2C18.54 15.2 18 14.66 18 14C18 13.34 18.54 12.8 19.2 12.8H22.8V9.2C22.8 8.54 23.34 8 24 8C24.66 8 25.2 8.54 25.2 9.2V12.8H28.8C29.46 12.8 30 13.34 30 14Z",
  fill: "#3448C9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.777 3.79128V8.59128C29.777 9.25128 29.237 9.79128 28.577 9.79128C27.917 9.79128 27.377 9.25128 27.377 8.59128V3.79128C27.377 3.17928 26.909 2.66328 26.297 2.60328C26.237 2.60328 26.201 2.59128 26.165 2.59128H4.57705C3.92905 2.59128 3.37705 3.14328 3.37705 3.79128V15.7913C3.37705 16.4393 3.92905 16.9913 4.57705 16.9913H6.97705V20.3633L10.2051 17.5793L10.8891 16.9913H18.977C19.637 16.9913 20.177 17.5313 20.177 18.1913C20.177 18.8513 19.637 19.3913 18.977 19.3913H11.7771L6.55705 23.9033C6.34105 24.0953 6.06505 24.1913 5.77705 24.1913C5.60905 24.1913 5.44105 24.1553 5.27305 24.0833C4.85305 23.8913 4.57705 23.4593 4.57705 22.9913V19.3913C2.59705 19.3913 0.977051 17.7713 0.977051 15.7913V3.79128C0.977051 1.81128 2.59705 0.191284 4.57705 0.191284H26.177C26.297 0.191284 26.429 0.203284 26.537 0.215284C28.349 0.395284 29.777 1.93128 29.777 3.79128Z",
  fill: "#3448C9"
});

function SvgSaveTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTemplate);
export default __webpack_public_path__ + "static/media/saveTemplate.8d036786.svg";
export { ForwardRef as ReactComponent };